import AddCostPoolRequest from "@/models/server/requests/AddCostPoolRequest";

export default class SaveCostPoolRequest extends AddCostPoolRequest {
    public costPoolId: string | null = null;
}